import React from 'react';
import axios from 'axios';
import { Spin, Row, Col, Typography} from "antd";
import { Loading3QuartersOutlined } from '@ant-design/icons';

function HttpLoader(props) {
    const [loading, setLoading] = React.useState(true);
    axios.interceptors.request.use((config) => {
        return config
    }, (error) => {
        setLoading(false)
        return Promise.reject(error);
    });
    
    axios.interceptors.response.use((response)=>{
        setLoading(false)
        return response;
    }, function (error) {
        setLoading(false)
        return Promise.reject(error);
    });
    let spinner = <Loading3QuartersOutlined style={{ fontSize: 56 }} spin/>;
    return (
        <>
        {loading &&
        <Row className="http-request-loader-container" justify="center" >
            <Col span={24} style={{ textAlign: 'center'}}>
                <Spin indicator={spinner}/>
            </Col>
            <Col span={24} style={{ textAlign: 'center', marginTop: 15}}>
                <Typography.Text>Carregando Conversa</Typography.Text>
            </Col>
        </Row>}
        </>
    );
}
export default HttpLoader